// Copyright (c) 2016 Deere & Company

import {isNotEmpty} from '../../../shared/services/claim-shared-helper';

const isNotNull = value => value !== null;

export const mapFormValidation = (property, value) => {

    const map = {
        contactDate: isNotNull,
        firstName: isNotEmpty,
        lastName: isNotEmpty,
        methodOfContact: isNotEmpty,
        referenceNumber1: isNotEmpty,
        relationship: isNotEmpty
    };

    return map[property](value);

};



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/services/claim-validation-helper.js